import "../css/header.css"
import {Button, Layout} from "antd"
import logo from "../ressources/images/sdma-logo.svg"
import {authenticationService} from "services/authentication.service"
import {useEffect, useState} from "react"
import Label from "./Label"
import user_icon from "../ressources/images/user.png"
import {useNavigate} from "react-router-dom"

const {Header} = Layout

export default function SiteHeader() {
	return (
		<Header className="header">
			<div className="inner_header">
				<div className="logo_container">
					<img alt="logo" className="logo" src={logo}/>
				</div>
				<UserTile/>
			</div>
		</Header>
	)
}

function UserTile() {
	const [user, setUser] = useState(null)
	const navigate = useNavigate()

	useEffect(() => {
		authenticationService.currentUser.subscribe(setUser)
	}, [])

	const logoutAction = () => {
		authenticationService.logout()
		navigate("/login")
	}

	if (user) {
		return (
			<div className="user_tile">
				<div className="logout">
					<Button size="large" type="primary" danger onClick={logoutAction}>
						<Label id="logout"/>
					</Button>
				</div>
				<div className="user_info">
					<img alt="user-icon" className="user_icon" src={user_icon}/>
					<span className="username">{user.username}</span>
				</div>
			</div>
		)
	} else {
		return (
			<div/>
		)
	}
}